<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal";
import EmployeeAPI from "@/services/employee/employeeAPI";
import CompanyAPI from "@/services/company/companyAPI";
import { dateFormat } from "@/utils/helpers/format";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import ItemAPI from "@/services/items/itemsAPI";
import auditoriaAPI from "../../../services/standards/auditoria/auditoriaAPI";
import AuditoriasPagination from "../../../components/standard/auditorias/AuditoriasPagination.vue";
import newScoresAPI from "../../../services/newScores/newScoresAPI";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "6.1.2 Auditoria anual del SG SST",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    AuditoriasPagination,
  },
  data() {
    return {
      title: "6.1.2 Auditoria anual del SG SST",

      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "6.1.2 Auditoria anual del SG SST",
          active: true,
        },
      ],
      list: [],
      usersList: [],

      item: null,
      itemStatus: "No cumplido",
      deleteCount: 0,
      itemData: null,
      search: "",

      lista: [],
      loading: true,

      auditoria: {
        deliver_report_date: null,
        deliver_plan_date: null,
        resources: null,
        auditor: null,
        process: null,
        risks_opportunities: null,
        scope: null,
        objetive_program: null,
        completion_date: null,
        start_date: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      submitted: false,

      form_submitting: false,

      company: this.$store.getters["company/getCompany"] || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

    };
  },
  validations: {
    auditoria: {
      start_date: {
        required,
      },
      completion_date: {
        required,
      },
      objetive_program: {
        required,
      },
      scope: {
        required,
      },
      risks_opportunities: {
        required,
      },
      process: {
        required,
      },
      auditor: {
        required,
      },
      resources: {
        required,
      },
      deliver_plan_date: {
        required,
      },
      deliver_report_date: {
        required,
      },
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(54)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    deleteAuditoria(id) {
      auditoriaAPI.delete(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 54,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              Swal.fire({
                title: "¡Éxito!",
                text: "¡Se ha sido eliminado con éxito!",
                type: "success",
                icon: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItems() {
      try {
        CompanyItemsAPI.getStatus(this.companyID, 54)
          .then((response) => {
            this.item = response || null;
            this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
          })
          .catch((error) => {
            this.item = null;
            this.itemStatus = null;
            console.log(error);
          });
      } catch (error) {
        this.item = null;
        this.itemStatus = null;
        console.log(error);
      }
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 54,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            style: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            style: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },

    fetch() {
      this.$refs.paginator.query();
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    async print() {
      try {
        const url = "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/FORMATOS_PROCESO_AUDITORIA_SGSST.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    async print2() {
      try {
        const url = "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/FORMATOS_PLAN_AUDITORIA.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    async print3() {
      try {
        const url = "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/FORMATOS_AUDITORIA_SGSST.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    getUsers() {
      CompanyAPI.getCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          EmployeeAPI.getEmployeesPromocion(response.id).then((res) => {
            this.usersList = res.employee;
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      auditoriaAPI
        .getAll(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          this.lista = response.data.data;
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    save() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.form_submitting = true;
        this.loading = false
        auditoriaAPI.save(this.auditoria)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 54,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading = true
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha registrado con éxito!",
                    type: "success",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  mounted() {
    this.getList();
    this.getItems();
    this.getItemData();
    this.getUsers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-6">
                  <CheckModal>
                    <p class="text-justify">
                      La empresa deberá realizar por lo menos una vez al año,
                      para verificar el cumplimiento del Decreto 1072 de 2015,
                      la resolución 0312 de 2019 y demás requisitos normativos
                      del SG SST.
                    </p>
                    <p class="text-justify">
                      En este ítem la empresa podrá realizar el programa de
                      auditorías, donde indicará cada una de las auditorias que
                      se realizarán en el año y posteriormente podrá encontrar
                      las herramientas para realizar el plan e informe de cada
                      auditoria, la cual será planificada con la participación
                      del Comité Paritario de Seguridad y Salud en el Trabajo o
                      Vigía.
                    </p>
                    <p class="text-justify">
                      En la base de conocimiento encontrará un procedimiento
                      guía para la realización de las auditorias.
                    </p>
                  </CheckModal>
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>

                <div class="col-12 text-right m-b-0">
                  <a @click="print" class="btn btn-outline-primary mx-1" style="cursor: pointer;">
                    Formatos Proceso de Auditoría SG-SST
                  </a>
                  <a @click="print2" class="btn btn-outline-primary mx-1" style="cursor: pointer;">
                    Formatos Plan de Auditoría
                  </a>
                  <a @click="print3" class="btn btn-outline-primary mx-1" style="cursor: pointer;">
                    Formatos Auditoría SG-SST
                  </a>
                </div>
              </div>

              <hr />
              <form class="form-group" @submit.prevent="save">

                <div class="form-row">
                  <b-form-group class="col-md-6 px-2" label="Fecha de realización" label-for="completion_date">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="completion_date"
                      v-model="auditoria.completion_date" :class="{
                        'is-invalid': submitted && $v.auditoria.completion_date.$error,
                      }">
                    </b-form-input>
                    <div v-if="submitted && !$v.auditoria.completion_date.required" class="invalid-feedback">
                      Este campo es requerido.
                    </div>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Objetivo del programa de auditoria"
                    label-for="objetive_program">
                    <b-form-input type="text" id="objetive_program" maxlength="100"
                      :disabled="!allowAccess() || !getRole('Crear')" v-model="auditoria.objetive_program" :class="{
                        'is-invalid': submitted && $v.auditoria.objetive_program.$error,
                      }">
                    </b-form-input>
                    <div v-if="submitted && !$v.auditoria.objetive_program.required" class="invalid-feedback">
                      Este campo es requerido.
                    </div>
                  </b-form-group>
                </div>

                <div class="form-row">
                  <b-form-group class="col-md-6 px-2" label="Alcance" label-for="scope">
                    <b-form-input type="text" id="scope" maxlength="100" :disabled="!allowAccess() || !getRole('Crear')"
                      v-model="auditoria.scope" :class="{
                        'is-invalid': submitted && $v.auditoria.scope.$error,
                      }">
                    </b-form-input>
                    <div v-if="submitted && !$v.auditoria.scope.required" class="invalid-feedback">
                      Este campo es requerido.
                    </div>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Riesgos y oportunidades" label-for="risks_opportunities">
                    <b-form-input type="text" id="risks_opportunities" maxlength="100"
                      :disabled="!allowAccess() || !getRole('Crear')" v-model="auditoria.risks_opportunities" :class="{
                        'is-invalid': submitted && $v.auditoria.risks_opportunities.$error,
                      }">
                    </b-form-input>
                    <div v-if="submitted && !$v.auditoria.risks_opportunities.required" class="invalid-feedback">
                      Este campo es requerido.
                    </div>
                  </b-form-group>
                </div>

                <div class="form-row">
                  <b-form-group class="col-md-6 px-2" label="Proceso" label-for="process">
                    <b-form-input type="text" id="process" maxlength="100"
                      :disabled="!allowAccess() || !getRole('Crear')" v-model="auditoria.process" :class="{
                        'is-invalid': submitted && $v.auditoria.process.$error,
                      }">
                    </b-form-input>
                    <div v-if="submitted && !$v.auditoria.process.required" class="invalid-feedback">
                      Este campo es requerido.
                    </div>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Fecha de Inicio" label-for="start_date">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="start_date"
                      v-model="auditoria.start_date" :class="{
                        'is-invalid': submitted && $v.auditoria.start_date.$error,
                      }">
                    </b-form-input>
                    <div v-if="submitted && !$v.auditoria.start_date.required" class="invalid-feedback">
                      Este campo es requerido.
                    </div>
                  </b-form-group>
                </div>

                <div class="form-row">
                  <b-form-group class="col-md-6 px-2" label="Auditor" label-for="auditor">
                    <b-form-input type="text" id="auditor" maxlength="100"
                      :disabled="!allowAccess() || !getRole('Crear')" v-model="auditoria.auditor" :class="{
                        'is-invalid': submitted && $v.auditoria.auditor.$error,
                      }">
                    </b-form-input>
                    <div v-if="submitted && !$v.auditoria.auditor.required" class="invalid-feedback">
                      Este campo es requerido.
                    </div>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Recursos" label-for="resources">
                    <b-form-input type="text" id="resources" maxlength="100"
                      :disabled="!allowAccess() || !getRole('Crear')" v-model="auditoria.resources" :class="{
                        'is-invalid': submitted && $v.auditoria.resources.$error,
                      }">
                    </b-form-input>
                    <div v-if="submitted && !$v.auditoria.resources.required" class="invalid-feedback">
                      Este campo es requerido.
                    </div>
                  </b-form-group>
                </div>

                <div class="form-row">
                  <b-form-group class="col-md-6 px-2" label="Fecha de entrega del plan" label-for="deliver_plan_date">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="deliver_plan_date"
                      v-model="auditoria.deliver_plan_date" :class="{
                        'is-invalid': submitted && $v.auditoria.deliver_plan_date.$error,
                      }">
                    </b-form-input>
                    <div v-if="submitted && !$v.auditoria.deliver_plan_date.required" class="invalid-feedback">
                      Este campo es requerido.
                    </div>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Fecha de entrega de informe"
                    label-for="deliver_report_date">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="deliver_report_date"
                      v-model="auditoria.deliver_report_date" :class="{
                        'is-invalid': submitted && $v.auditoria.deliver_report_date.$error,
                      }">
                    </b-form-input>
                    <div v-if="submitted && !$v.auditoria.deliver_report_date.required" class="invalid-feedback">
                      Este campo es requerido.
                    </div>
                  </b-form-group>
                </div>


                <div class="form-group text-right m-b-0">
                  <button type="submit" :disabled="this.form_submitting === true" class="btn btn-primary mx-1">
                    Guardar
                  </button>
                </div>

                <hr v-if="getRole('Consultar')" />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <form @submit.prevent="fetch()" class="form-inline">
                            <div class="form-group mr-2">
                              <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                class="form-control px-2" placeholder="Buscar"></b-form-input>

                              <div class="col-1">
                                <button type="submit" class="btn btn-primary px-2">
                                  Buscar
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                          <thead>
                            <tr>
                              <th class="text-center align-middle">
                                Fecha creación
                              </th>
                              <th class="text-center align-middle">
                                Fecha de inicio
                              </th>

                              <th class="text-center align-middle">
                                Auditor
                              </th>
                              <th class="text-center align-middle">
                                Objetivo del programa
                              </th>
                              <th class="text-center align-middle">
                                Proceso
                              </th>
                              <th class="text-center align-middle">Acciones</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="dato in lista" :key="dato.id">
                              <td class="text-center align-middle">
                                {{ dateConvert(dato.created_at) }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.start_date }}
                              </td>

                              <td class="text-center align-middle">
                                {{ dato.auditor }}
                              </td>

                              <td class="text-center align-middle">
                                {{ dato.objetive_program }}
                              </td>

                              <td class="text-center align-middle">
                                {{ dato.process }}
                              </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>
                                    <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')
                                      " :to="{
                                        path: `/forms/estandares/auditoria-plan/${dato.id}`,
                                      }">
                                      Subir Evidencias
                                    </b-dropdown-item>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()
                                      " v-b-modal="`modal${dato.id}`">Editar</b-dropdown-item>

                                    <b-modal :id="`modal${dato.id}`" body-class="p-4" hide-header hide-footer size="sm">
                                      <div class="text-justify">
                                        <h4 class="mt-2 text-primary text-center">
                                          Advertencia
                                        </h4>
                                        <p class="mt-3">
                                          Al modificar esta información se
                                          quitará el puntaje correspondiente a
                                          este ítem y será necesario realizar
                                          nuevamente la validación por parte del
                                          usuario responsable de Emisión.
                                        </p>
                                        <button :disabled="!getRole('Editar') || !allowAccess()
                                          " type="button" class="btn btn-primary my-2 mx-2">
                                          <router-link class="text-white" :to="{
                                            path: `/forms/estandares/auditoria-editar/${dato.id}`,
                                          }">Editar
                                          </router-link>
                                        </button>
                                        <button type="button" @click="
                                          $bvModal.hide(`modal${dato.id}`)
                                          " class="btn btn-danger btn mx-2" data-dismiss="modal">
                                          Cancelar
                                        </button>
                                      </div>
                                    </b-modal>
                                    <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()
                                      " v-on:click="deleteAuditoria(dato.id)">Eliminar</b-dropdown-item>
                                  </b-dropdown>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <AuditoriasPagination ref="paginator" :search="search" @fetch="(items) => (lista = items)" />
                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
